import { ReactNode } from 'react';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import {
  ArtifactCardBase,
  DefaultArtifactListItem,
} from '@spotify/plugin-confidence-projects-react';

type ResolvedNameHook = (artifact: AttachmentFragment) => string | undefined;

export interface ResolvedListItemProps {
  artifact: AttachmentFragment;
  icon?: ReactNode;
  onSelect: () => void;
  onDelete?: () => void;
}

export interface ResolvedCardProps {
  artifact: AttachmentFragment;
  onNavigate: () => void;
  onDelete?: () => void;
}

export const makeResolvedArtifactWrappers = (
  useResolvedName: ResolvedNameHook,
) => {
  const ListItem = ({
    artifact,
    icon,
    onSelect,
    onDelete,
  }: ResolvedListItemProps) => (
    <DefaultArtifactListItem
      artifact={artifact}
      resolvedDisplayName={useResolvedName(artifact)}
      icon={icon}
      onSelect={onSelect}
      onDelete={onDelete}
    />
  );

  const Card = ({ artifact, onNavigate, onDelete }: ResolvedCardProps) => (
    <ArtifactCardBase
      artifact={artifact}
      resolvedDisplayName={useResolvedName(artifact)}
      onNavigate={onNavigate}
      onDelete={onDelete}
    />
  );

  return { ListItem, Card };
};
